import { render, staticRenderFns } from "./ProfileAddresses.vue?vue&type=template&id=524a997c&"
import script from "./ProfileAddresses.vue?vue&type=script&lang=js&"
export * from "./ProfileAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports